(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("seqviz-plus", [], factory);
	else if(typeof exports === 'object')
		exports["seqviz-plus"] = factory();
	else
		root["seqviz-plus"] = factory();
})(this, () => {
return 